class Order {
  constructor(id, status, currency, total, fee, totalWithFee) {
    this.id = id;
    this.status = status;
    this.currency = currency;
    this.total = total;
    this.fee = fee;
    this.totalWithFee = totalWithFee;
  }
}

export default Order;
